import { createSlice } from '@reduxjs/toolkit';
import { RootState } from '../../store';
import { StatusControlState } from './StatusControl.type';
import { getStatusControlListThunk } from './StatusControl.thunk';

const SLICE_NAME = 'statusControl';

const initialState: StatusControlState = {
  items: [],
  isLoading: false,
  pagination: undefined,
};

export const statusControlSlice = createSlice({
  name: SLICE_NAME,
  initialState,
  reducers: {
    setStatusControlList: (state, action) => ({
      ...state,
      items: action.payload,
    }),
  },
  extraReducers: builder => {
    builder.addCase(getStatusControlListThunk.pending, state => {
      state.isLoading = true;
    });
    builder.addCase(
      getStatusControlListThunk.fulfilled,
      (state, { payload }) => {
        const { data, pagination } = payload;
        state.isLoading = false;
        state.items = data;
        state.pagination = {
          currentPage: pagination.current_page,
          lastPage: pagination.last_page,
          perPage: pagination.per_page,
          from: pagination.from,
          to: pagination.to,
          total: pagination.total,
        };
      },
    );
    builder.addCase(getStatusControlListThunk.rejected, state => {
      state.isLoading = false;
    });
  },
});

export const getStatusControlList = (state: RootState) =>
  state.statusControl.items;

export const getStatusControlListPagination = (state: RootState) =>
  state.statusControl.pagination;

export const { setStatusControlList } = statusControlSlice.actions;

export default statusControlSlice.reducer;
